import configdata from "../../config.json";
import { productSliceAction } from "./ProductSlice";
import { getApi } from "../BaseApi";
import { getOnlyValueFromSelectObject } from "../UseAbleFun";
import { appLevelSliceActions } from "../AppLevelApi/AppLevelSlice";
export const getAllProductItems = () => {
  return async (dispatch) => {
    dispatch(appLevelSliceActions.setLoadingState());
    const res = await getApi("get", `${configdata.SERVER_URL}/api/products`);

    let discount_amount = [];
    let price = [];
    let quality = [];
    let id = [];
    res.data.products.forEach((item) => {
      item.quality.forEach((item) => {
        discount_amount.push(
          `${
            item.discount_type === "flat"
              ? `Rs.${item.discount_amount}`
              : `${item.discount_amount} (%)`
          }`
        );
        price.push(item.price);
        quality.push(item.quality);
        id.push(item.id);
      });
      item.discount_amount = discount_amount;
      item.price = price;
      item.quality = quality;
      item.id = id;
      discount_amount = [];
      price = [];
      quality = [];
      id = [];
    });

    let newResData = {};
    res.data.products = res.data.products.map((item) => {
      Object.keys(item).forEach((data) => {
        if (typeof item[data][0] !== "object") {
          newResData[data] = item[data];
        }
      });
      item = newResData;
      newResData = {};
      return item;
    });

    dispatch(appLevelSliceActions.setLoadingState());

    dispatch(productSliceAction.getAllProduct(res.data.products));
  };
};
export const createProductItem = (data, duplicateData, createOrAddMore) => {
  let newDuplicateData = { ...duplicateData };

  const qualityIdList = newDuplicateData.quality.map((item) => {
    const value = item.value;
    return value;
  });
  const discountType = newDuplicateData.discount_type.map((item) => {
    const value = item.value;
    return value;
  });
  newDuplicateData.quality = qualityIdList;
  newDuplicateData.discount_type = discountType;
  data = { ...data, ...newDuplicateData };
  // data.push({ ...newDuplicateData });
  const { form } = getOnlyValueFromSelectObject(data);

  return async (dispatch) => {
    dispatch(appLevelSliceActions.setLoadingState());

    let resurl = `${configdata.SERVER_URL}/api/products/stores`;

    if (createOrAddMore === "addmore") {
      resurl = `${configdata.SERVER_URL}/api/products/qualitys`;
    }
    let resData = await getApi("post", resurl, form);
    if (resData?.error) {
      if (resData?.errorType === "single") {
        dispatch(
          appLevelSliceActions.setError({ msg: resData.message, isError: true })
        );
      } else {
        dispatch(
          productSliceAction.setErrorData({
            message: resData.message,
            isError: true,
          })
        );
      }

      dispatch(appLevelSliceActions.setLoadingState());
      return;
    }
    dispatch(
      productSliceAction.setErrorData({
        message: {},
        isError: false,
      })
    );
    dispatch(appLevelSliceActions.setIsSuccess(true));
    dispatch(productSliceAction.setInitialData());
    dispatch(productSliceAction.setDuplicateInitialData());
    dispatch(appLevelSliceActions.setLoadingState());
    window.location.reload(false);
    dispatch(getAllProductItems());
  };
};
export const getDataForEdit = (id, qualityList) => {
  return async (dispatch) => {
    dispatch(appLevelSliceActions.setLoadingState());
    const res = await getApi(
      "get",
      `${configdata.SERVER_URL}/api/products/edit/${id}`
    );

    dispatch(appLevelSliceActions.setLoadingState());
    const data = { ...res.data.products[0] };

    const quality = qualityList.find((item) => {
      return item.value === data.quality_id;
    });

    data.quality = {
      value: quality.value,
      label: quality.label,
      type: quality.type,
    };
    data.status = {
      value: `${data.status}`,
      label: data.status === "active" ? "Active" : "Deactive",
      type: "status",
    };
    data.discount_type = {
      value: `${data.discount_type}`,
      label: data.discount_type === "flat" ? "Flat" : "%",
      type: "discount_type",
    };

    dispatch(productSliceAction.getProductDataEdit(data));
  };
};

export const updateProductItem = (data) => {
  const { form } = getOnlyValueFromSelectObject(data);

  return async (dispatch) => {
    dispatch(appLevelSliceActions.setLoadingState());
    const resData = await getApi(
      "post",
      `${configdata.SERVER_URL}/api/products/update/${data.id}`,
      form
    );

    if (resData?.error) {
      if (resData?.errorType === "single") {
        dispatch(
          appLevelSliceActions.setError({ msg: resData.message, isError: true })
        );
      } else {
        dispatch(
          productSliceAction.setErrorData({
            message: resData.message,
            isError: true,
          })
        );
      }

      dispatch(appLevelSliceActions.setLoadingState());
      return;
    }
    dispatch(
      productSliceAction.setErrorData({
        message: {},
        isError: false,
      })
    );
    dispatch(appLevelSliceActions.setIsSuccess(true));
    dispatch(productSliceAction.setInitialData());
    dispatch(productSliceAction.setDuplicateInitialData());
    dispatch(appLevelSliceActions.setLoadingState());
    window.location.reload(false);
    dispatch(getAllProductItems());
  };
};

export const deleteProductItem = (id) => {
  return async (dispatch) => {
    dispatch(appLevelSliceActions.setLoadingState());
    await getApi("get", `${configdata.SERVER_URL}/api/products/delete/${id}`);
    dispatch(appLevelSliceActions.setIsSuccess(true));
    dispatch(appLevelSliceActions.setLoadingState());
  };
};
